import { describe, expect, it } from '@jest/globals';
import { sortObjectKeys } from './sortObjectKeys.js';

describe('sortObjectKeys', () => {
  it('should return an empty object when given an empty object', () => {
    const input = {};
    const output = sortObjectKeys(input);
    expect(output).toEqual({});
  });

  it('should return the same object when given an object with one key', () => {
    const input = { a: 1 };
    const output = sortObjectKeys(input);
    expect(output).toEqual({ a: 1 });
  });

  it('should return a sorted object when given an object with multiple keys', () => {
    const input = { b: 2, a: 1, c: 3 };
    const output = sortObjectKeys(input);
    expect(output).toEqual({ a: 1, b: 2, c: 3 });
  });

  it('should not mutate the original object', () => {
    const input = { b: 2, a: 1, c: 3 };
    const copy = { ...input };
    sortObjectKeys(input);
    expect(input).toEqual(copy);
  });
});
